var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAskNeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.1368,
    height: 20.1368,
    rx: 7.0041,
    fill: "#FD9567"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3058 9.55489C12.3007 8.70469 11.3511 7.7951 10.5009 5.83222C10.1782 5.03438 9.90624 4.76713 9.51865 5.7197C8.67079 7.74977 7.65883 8.7172 5.66615 9.55499C5.4661 9.6472 5.10586 9.80739 5.10352 9.99728C5.10586 10.1872 5.46376 10.3474 5.66615 10.4396C7.65645 11.2749 8.67085 12.2447 9.51865 14.2749C9.91092 15.2446 10.1836 14.9399 10.5009 14.1623C11.3511 12.2002 12.3006 11.2899 14.3058 10.4397C14.516 10.3396 14.863 10.2068 14.8981 10.0075V9.98486C14.863 9.78716 14.5184 9.65274 14.3058 9.55272V9.55489Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskNeo);
export default __webpack_public_path__ + "static/media/AskNeo.4a49be3b6e60dc411f85177fcc5b669a.svg";
export { ForwardRef as ReactComponent };